module.exports = __webpack_public_path__ + "static/media/Anca-about.8d15cfe0.webp";